import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CompanyStatus from 'companies/components/CompanyStatus';
import CompanyDelete from 'companies/components/CompanyDelete';
import CompanyActions from 'companies/components/CompanyActions';

const Company = ({
  t = (key) => key,
  role,
  isRoot,
  permissions,
  company,
  handleClick = () => {},
  handleDelete = () => {},
  handleToggle = () => {},
}) => {
  return (
    <div className="col-sm-6 col-md-6 col-lg-4">
      <div
        className={classnames('card card-company mt-5 mb-5', {
          disabled: !company.active,
        })}
        onClick={handleClick}
      >
        <div className="text-center rounded-circle card-avatar">
          <i className="fa fa-building-o fa-3x" />
        </div>
        <div className="card-body mt-5 text-center">
          <h5 className="card-title mt-0">{company.shortname}</h5>
          <p className="card-text">{company.name}</p>
          <CompanyStatus t={t} isActive={company.active} userRoleName={role.name || ''} isDemo={company.isDemo } />
          <CompanyActions
            t={t}
            companyId={company.id}
            isActive={company.active}
            isLoading={company.isLoading}
            canEdit={
              (company.active && role.permissions.indexOf('acl.companies.edit') > -1) || false
            }
            canToggle={isRoot}
            handleToggle={handleToggle}
          />
        </div>
        <CompanyDelete canDelete={isRoot} handleClick={handleDelete} t={t} />
      </div>
    </div>
  );
};

Company.propTypes = {
  t: PropTypes.func,
  handleClick: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleToggle: PropTypes.func.isRequired,
  isRoot: PropTypes.bool.isRequired,
  role: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
};

export default translate()(Company);



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/components/Company.js